import { render, staticRenderFns } from "./production-prescription-charts.vue?vue&type=template&id=b507eb66&scoped=true&lang=pug&"
import script from "./production-prescription-charts.vue?vue&type=script&lang=ts&"
export * from "./production-prescription-charts.vue?vue&type=script&lang=ts&"
import style0 from "./production-prescription-charts.vue?vue&type=style&index=0&id=b507eb66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b507eb66",
  null
  
)

export default component.exports